import { CSSProperties, FunctionComponent, HTMLAttributes, ReactNode } from 'react';

type CardContentUIProps = {
  children?: ReactNode,
} & HTMLAttributes<HTMLDivElement>;

// MUI CardContent: padding 16px, with `&:last-child { padding-bottom: 24px }`.
// Every current call site renders CardContent as the sole/last child of its Card,
// so the effective padding is 16/16/24/16 — encoded directly here (a :last-child
// rule can't be expressed inline, and inline is required to stay overridable under
// `important: '#root'`). Call-site style wins.
const CardContentUI: FunctionComponent<CardContentUIProps> = ({ style, className = '', children, ...rest }) => {
  const baseStyle: CSSProperties = {
    padding: 16,
    paddingBottom: 24,
    ...style,
  };
  return (
    <div className={className} style={baseStyle} {...rest}>
      {children}
    </div>
  );
};

export default CardContentUI;
